module.exports = __webpack_public_path__ + "assets/asset_dumpster_fire.31eb37bd.svg";